.footer {
  margin-block-start: var(--space-9);
  border-block-start: 1px solid var(--border);
  background: var(--surface);
  padding-block: var(--space-6);
}

.inner {
  display: grid;
  gap: var(--space-3);
}

.terms {
  max-inline-size: var(--measure);
  color: var(--text-muted);
  font-size: var(--text-sm);
}

/*
 * The footer's last line: the public-site links, with the colour-theme control at its end
 * (`APP-017`). Two items on one row at width, stacking on a phone — where the control wraps
 * under the links rather than widening the page, which is the failure that drove it out of
 * the masthead in the first place.
 */
.bottom {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-4);
}

.links {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-4);
  margin: 0;
  font-size: var(--text-sm);
}

/*
 * The theme control and sign-out, at the end of the line (`APP-022`). Wrapping, so on a
 * phone the two stack under the links rather than widening the page — which is the failure
 * that drove both of them out of the masthead in the first place.
 */
.controls {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-4);
}

/*
 * A sign-out that never reached core (`APP-017`, moved by `APP-022`). Its own line in the
 * footer's grid so the sentence is readable rather than a sliver beside two controls, and
 * coloured as a warning rather than a failure: nothing broke, the founder simply is not
 * signed out yet.
 */
.signOutFailed {
  margin: 0;
  font-size: var(--text-sm);
  line-height: 1.4;
  color: var(--text-muted);
}

.build {
  font-family: var(--font-figure);
  font-size: var(--text-xs);
  color: var(--text-muted);
}
